module.exports = __webpack_public_path__ + "static-v-shop/1782224859977/img/banner_desk-01.3a56e840.jpg";